<template>
  <span class="shape-preview" :style="{ '--cols': cols, '--rows': rows }">
    <span
      v-for="(cell, i) in flat"
      :key="i"
      class="shape-preview__cell"
      :class="{ [`shape-preview__cell--on shape-preview__cell--${terrain}`]: cell }"
    />
  </span>
</template>

<script>
// A tiny swatch of a polyomino, for the option buttons. Pure CSS boxes -
// crisper than a scaled tile image at 14px a cell.
import { normalize } from '@/engine/board';

export default {
  name: 'ShapePreview',
  props: {
    cells: { type: Array, required: true },
    terrain: { type: String, default: 'forest' },
  },
  computed: {
    norm() { return normalize(this.cells); },
    rows() { return Math.max(...this.norm.map(([r]) => r)) + 1; },
    cols() { return Math.max(...this.norm.map(([, c]) => c)) + 1; },
    flat() {
      const set = new Set(this.norm.map(([r, c]) => `${r},${c}`));
      const out = [];
      for (let r = 0; r < this.rows; r += 1) {
        for (let c = 0; c < this.cols; c += 1) out.push(set.has(`${r},${c}`));
      }
      return out;
    },
  },
};
</script>
